module.exports = __webpack_public_path__ + "static/media/member-emblem-red.0b290adf.png";